import { Controller } from '@hotwired/stimulus';

// #1841: 「給与を試す」フォームの二重送信防止。submit 時にボタンを即 disabled 化し、
// ラベルを「作成しています…」に差し替える。
export default class extends Controller {
  static targets = ['button'];
  static values = { submittingLabel: { type: String, default: '作成しています…' } };

  submit() {
    if (!this.hasButtonTarget) return;
    // 既に無効化済みなら何もしない（多重発火防止）。
    if (this.buttonTarget.disabled) return;
    this.buttonTarget.disabled = true;
    this.buttonTarget.classList.add('is-submitting');
    const label = this.buttonTarget.querySelector('[data-trial-submit-target="label"]');
    if (label) label.textContent = this.submittingLabelValue;
  }
}
